module.exports = __webpack_public_path__ + "static/media/Group 518.89473c25.svg";